import type { Logger } from "~/tools/logger";
import { EMPTY, type Observable } from "~/tools/rxjs";

import { Messages } from "../../common/Messages";
import { notification } from "../../components/react/notification/Notification";

export const defaultNotificationEpicErrorHandler =
	(logger: Logger) =>
	(error: any): Observable<never> => {
		notification.warning({ message: Messages.genericStreamError() });
		logger.error("Got error", error);
		return EMPTY;
	};
